// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"76\" height=\"76\" viewBox=\"0 0 76 76\" fill=\"none\"> <circle cx=\"38\" cy=\"38\" r=\"35\" stroke=\"#D9DBE0\" stroke-width=\"6\"/> <path d=\"M38 3C57.33 3 73 18.67 73 38C73 44.7805 71.0719 51.1107 67.734 56.4722\" stroke=\"#2972F0\" stroke-width=\"6\" stroke-linecap=\"round\"/> </svg>";
// Exports
module.exports = code;